import React, { useState, useRef, useEffect } from "react";
import "./AddToCalendar.css";
import {
  buildGoogleCalendarUrl,
  downloadIcs,
  isCalendarReady,
} from "../utils/calendar";

const CalendarIcon = () => (
  <svg
    className="beef-atc__icon"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="3"
      y="4.5"
      width="18"
      height="16"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M3 9h18M8 2.5v4M16 2.5v4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default function AddToCalendar({ event, id }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!isCalendarReady(event)) return null;

  const fileName = (id || "beef-event") + ".ics";

  return (
    <div className="beef-atc" ref={ref}>
      <button
        type="button"
        className="beef-atc__trigger"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <CalendarIcon />
        Add to Calendar
      </button>

      {open ? (
        <div className="beef-atc__menu" role="menu">
          <a
            role="menuitem"
            className="beef-atc__item"
            href={buildGoogleCalendarUrl(event)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
          >
            Google Calendar
          </a>
          <button
            role="menuitem"
            type="button"
            className="beef-atc__item"
            onClick={() => {
              downloadIcs(event, fileName);
              setOpen(false);
            }}
          >
            Apple Calendar
          </button>
          <button
            role="menuitem"
            type="button"
            className="beef-atc__item"
            onClick={() => {
              downloadIcs(event, fileName);
              setOpen(false);
            }}
          >
            Outlook
          </button>
        </div>
      ) : null}
    </div>
  );
}
